import classNames from "classnames/bind";
import { IconProps } from "common/assets/icons/types";
import * as React from "react";
import styles from "./Icon.module.css";

const classNameBuilder = classNames.bind(styles);

export const FolderIcon: React.FC<IconProps> = ({
  color = "#fd6a65",
  withBackground,
}) => {
  const renderContent = (): React.JSX.Element => {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g fill="none" fillRule="evenodd">
          <path d="M0 0h32v32H0z" />
          <g fill={color}>
            <path
              d="M10.978 18.609 9.75 24.75h11.065c1.402 0 2.103 0 2.677-.25a3 3 0 0 0 1.259-1.033c.358-.514.496-1.2.77-2.575l.464-2.314c.262-1.312.393-1.968.216-2.482a2 2 0 0 0-.879-1.07c-.468-.276-1.137-.276-2.475-.276h-7.162c-1.402 0-2.102 0-2.677.251a3 3 0 0 0-1.258 1.032c-.36.514-.497 1.201-.772 2.576Z"
              fillRule="nonzero"
              opacity=".12"
            />
            <path d="M9.75 7h-.116c-.818 0-1.376 0-1.854.128a3.75 3.75 0 0 0-2.652 2.651C5 10.26 5 10.816 5 11.634V19.982c0 .813 0 1.469.043 2 .045.546.14 1.026.366 1.47a3.75 3.75 0 0 0 1.639 1.64c.444.226.924.32 1.47.365a16.426 16.426 0 0 0 1.232.043h12c.03 0 .06-.002.089-.005.249-.005.475-.013.68-.028.466-.035.878-.108 1.273-.28a3.751 3.751 0 0 0 1.574-1.29c.246-.354.399-.744.524-1.194.121-.434.229-.973.362-1.636l.005-.028.463-2.314.007-.033c.125-.628.229-1.147.276-1.572.049-.439.048-.86-.094-1.269a2.75 2.75 0 0 0-1.207-1.473c-.368-.215-.773-.3-1.204-.339-.006-.51-.031-.907-.126-1.26a3.75 3.75 0 0 0-2.651-2.651C21.242 10 20.684 10 19.866 10h-3.128c-.77 0-1.032-.005-1.27-.062a2.25 2.25 0 0 1-.65-.27c-.21-.128-.4-.31-.944-.854l-.351-.352-.042-.041c-.318-.318-.537-.538-.786-.717a3.75 3.75 0 0 0-1.58-.654C10.812 7 10.5 7 10.052 7H9.75Zm13.246 7c-.006-.435-.024-.652-.073-.832a2.25 2.25 0 0 0-1.59-1.591c-.263-.07-.605-.077-1.583-.077h-3.097c-.652 0-1.103 0-1.536-.104a3.75 3.75 0 0 1-1.084-.449c-.38-.232-.698-.551-1.159-1.012l-.06-.06-.352-.352c-.375-.375-.505-.502-.642-.6a2.25 2.25 0 0 0-.948-.393c-.167-.028-.349-.03-.88-.03H9.75c-.978 0-1.32.007-1.582.077a2.25 2.25 0 0 0-1.591 1.59c-.07.263-.077.605-.077 1.583v8.2c0 .853 0 1.447.038 1.91.038.453.107.714.207.912.216.423.56.767.984.983.197.1.458.17.912.207.15.012.314.02.497.026l1.105-5.526.005-.028c.133-.664.24-1.202.362-1.637.125-.45.278-.84.524-1.193a3.75 3.75 0 0 1 1.574-1.29c.395-.173.807-.246 1.273-.28.45-.034.999-.034 1.676-.034H22.996ZM21.17 24H10.665l1.049-5.244c.14-.698.237-1.182.34-1.556.103-.366.198-.577.31-.738a2.25 2.25 0 0 1 .944-.773c.18-.079.405-.131.784-.16.388-.028.881-.029 1.593-.029h7.162c.682 0 1.145.001 1.498.032.346.03.503.084.598.14.257.15.451.388.549.67.036.104.058.268.02.613-.039.352-.129.806-.263 1.476l-.463 2.314c-.14.698-.237 1.181-.34 1.556-.103.366-.198.577-.31.737a2.25 2.25 0 0 1-.944.774c-.18.078-.405.13-.784.159-.32.024-.711.028-1.238.03Z" />
          </g>
        </g>
      </svg>
    );
  };

  if (withBackground) {
    return (
      <div
        className={classNameBuilder({
          withBackground,
        })}
      >
        {renderContent()}
      </div>
    );
  }

  return renderContent();
};
